var currentLang = function() {
	var html = document.documentElement;
	var langAttr = html.getAttribute('lang');
	if(langAttr == null)
		return "";
	else
		return langAttr;
};

module.exports = currentLang;



// WEBPACK FOOTER //
// ./lib/currentLang.js